<template>
    <div class="parametric-sort">
        <div v-click-outside="hideSelect"
             class="parametric-select__wrapper">
            <div class="parametric-select__container">
                <button class="parametric-select__button"
                        :class="{ 'is-active': showOptions, 'is-filled': selectText !== null }"
                        @click="toggleSelect">
                    {{ selectText }}
                    <span class="parametric-select__button-icon">
                        <IconDown />
                    </span>
                </button>

                <transition name="fadebottom-fast">
                    <div v-show="showOptions"
                         ref="selectList"
                         class="parametric-select__list-wrapper">
                        <ul class="parametric-select__list">
                            <template v-for="(item, key) in items">
                                <li v-for="(type, order) in item"
                                    :key="type"
                                    :class="['parametric-select__list-item', {'is-active': isCurrentType(key, order)}]"
                                    @click="_changeSort(key, order)">
                                    <div class="parametric-select__list-item-label">
                                        {{ type }}
                                        <span class="parametric-select__list-icon">
                                            <IconCheckSmall />
                                        </span>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import IconCheckSmall from '@/components/Icons/CheckSmall';
import IconDown from '@/components/Icons/Down';
import {mapActions, mapGetters} from 'vuex';
import Utils from '@/helpers/Utils';

/**
 * Компонент сортировки в параместрическом выборщики
 */
export default {
    name: 'ParametricSort',

    components: {
        IconCheckSmall,
        IconDown,
    },

    directives: {
        ClickOutside
    },

    props: {
        items          : Object,  // объект с доступными сортировками
        currentSortType: Object   // текущая выбранная сортировка
    },

    data() {
        return {
            showOptions: false  // показываем ли сейчас список опций
        };
    },

    computed: {
        ...mapGetters({
            activeType: 'parametric/GET_ACTIVE_TYPE' // текущий выбранный тип показываемых помещний
        }),

        /**
         * Текст выбранной выводимой сортировки
         * @return {null|*}
         */
        selectText() {
            if (!this.items || Object.keys(this.currentSortType).length === 0) {
                return null;
            }

            return this.items[this.currentSortType.type][this.currentSortType.order];
        }
    },

    methods: {
        ...mapActions('parametric', ['changeSort', 'sendSortAndPaginationRequest']),

        /**
         * Событие при смене сортировки
         * @param {String} type - тип сортировки
         * @param {String} order - направление сортировки
         * @private
         */
        _changeSort(type, order) {
            const body = {
                category: this.activeType,
                sortData: {
                    type,
                    order
                }
            };

            this.changeSort(body);
            this.$emit('onChangeSort');
            this.hideSelect();
            this.sendSortAndPaginationRequest(true)
                .then(() => {
                    this.$emit('onEndChangeSort');
                });
        },

        /**
         * Проверяет является ли переданная сортировка активной
         * @param {String} type - тип сортировки
         * @param {String} order - направление сортировки
         * @return {boolean} - является ли эта сортировка выбранной (активной)
         */
        isCurrentType(type, order) {
            return type === this.currentSortType?.type && order === this.currentSortType?.order;
        },

        /**
         * Открывает/скрывает список сортировок
         */
        toggleSelect() {
            this.showOptions = !this.showOptions;

            if (this.showOptions) {
                Utils.bodyFixed(this.$refs.selectList);
            } else {
                Utils.bodyStatic();
            }
        },

        /**
         * Скрывает список сортировок
         */
        hideSelect() {
            if (this.showOptions) {
                this.showOptions = false;

                Utils.bodyStatic();
            }
        }
    }
};
</script>

<style lang="scss">
@import "ParametricSort";
</style>
